import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import { FaMapMarkedAlt, FaLink, FaChartBar } from "react-icons/fa";

import "./WaterReport5.css";

const chartData = [
  { county: "Beaver", usage: 456, goal: 390 },
  { county: "Cache", usage: 304, goal: 233 },
  { county: "Davis", usage: 228, goal: 188 },
  { county: "Salt Lake", usage: 206, goal: 186 },
  { county: "Utah", usage: 216, goal: 172 },
];

const tableData = [
  { county: "Beaver", avg1: 688, avg2: 548, val2024: 456, goal: 390 },
  { county: "Box Elder", avg1: 355, avg2: 339, val2024: 350, goal: 266 },
  { county: "Cache", avg1: 275, avg2: 285, val2024: 304, goal: 233 },
  { county: "Davis", avg1: 247, avg2: 214, val2024: 228, goal: 188 },
  { county: "Salt Lake", avg1: 198, avg2: 180, val2024: 206, goal: 186 },
  { county: "Utah", avg1: 218, avg2: 200, val2024: 216, goal: 172 },
];

const WaterReport5 = () => {
  return (
    <div className="report-wrapper">
      {/* HEADER */}
      <div className="report-header">
        <h1>
          <FaMapMarkedAlt /> County Water Usage Analysis
        </h1>
        <p>
          This report compares county-level water usage against 2030 goals to
          identify performance gaps.
        </p>

        <a
          href="https://waterdesk.org/2025/12/utah-has-county-by-county-water-goals-which-ones-are-hitting-them/"
          target="_blank"
          rel="noreferrer"
          className="link-btn"
        >
          <FaLink /> Data Source
        </a>
      </div>

      {/* KPI */}
      <div className="kpi-row">
        <div className="kpi blue">
          <h2>2024 Usage</h2>
          <p>Latest County Data</p>
        </div>

        <div className="kpi green">
          <h2>2030 Goal</h2>
          <p>Goal Reduction</p>
        </div>

        <div className="kpi red">
          <h2>Gap</h2>
          <p>Above / Below Goal</p>
        </div>
      </div>

      {/* CHART */}
      <div className="section-card">
        <h3>
          <FaChartBar /> 2024 vs Goal Comparison
        </h3>

        <ResponsiveContainer width="100%" height={360}>
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" opacity={0.1} />

            <XAxis
              dataKey="county"
              label={{
                value: "County",
                position: "insideBottom",
                offset: -10,
                style: { fill: "#555" },
              }}
            />

            <YAxis
              label={{
                value: "GPCD",
                angle: -90,
                position: "insideLeft",
                dx: 0,
                dy: 20,
                style: { fill: "#555", textAnchor: "middle" },
              }}
            />

            <Tooltip formatter={(value) => `${value} GPCD`} />

            <Bar dataKey="usage" fill="#60a5fa" name="2024" />
            <Bar dataKey="goal" fill="#4ade80" name="Goal" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* TABLE */}
      <div className="section-card">
        <h3>County-Level Data</h3>

        <div className="table-scroll">
          <table className="clean-table">
            <thead>
              <tr>
                <th>County</th>
                <th>2015–19 Avg (GPCD)</th>
                <th>2020–24 Avg (GPCD)</th>
                <th>2024 (GPCD)</th>
                <th>2030 Goal (GPCD)</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {tableData.map((row, i) => {
                const isAbove = row.val2024 > row.goal;

                return (
                  <tr key={i}>
                    <td>{row.county}</td>
                    <td>{row.avg1}</td>
                    <td>{row.avg2}</td>
                    <td>{row.val2024}</td>
                    <td>{row.goal}</td>
                    <td>
                      <span className={`badge ${isAbove ? "bad" : "good"}`}>
                        {isAbove ? "Above Goal" : "On Track"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WaterReport5;
